import { createStyles } from '@material-ui/core';
import Colours from 'bz-core-controls/styles/colours';

export default createStyles({
  noOneHereContainer: {
    height: '100%',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
    background: 'rgba(0,0,0,0.6)'
  },
  noOneHere: {
    display: 'grid',
    alignSelf: 'center',
    fontSize: 20,
    textAlign: 'center'
  },
  localMedia: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '20%',
    zIndex: 1000
  },
  remoteMedia: {
    color: Colours.white,
    height: '100%',
    width: '100%',
    alignSelf: 'center'
  },
  videoWrapper: {
    background: 'black',
    zIndex: 2000,
    boxShadow: '4px 12px 12px rgba(0,0,0,0.6)',
    borderRadius: '4px'
  },
  videoElements: {
    background: 'black', // needed for safari
    position: 'relative',
    width: '100%',
    height: '100%'
  }
});

export const playbackStyles = createStyles({
  controls: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    display: 'grid',
    gridColumnGap: '10px',
    paddingBottom: 10,
    gridTemplateColumns: '1fr repeat(4, auto) 1fr',
    justifySelf: 'center'
  },
  red: { backgroundColor: Colours.red900 }
});
